import {
  CHECK_TERMS,
  initialConsentState,
  SIGN_CONSENT,
  UPDATE_CONSENT_TEXT,
} from './constants'

export const consentReducer = (
  state: ConsentState = initialConsentState,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): ConsentState => {
  switch (action.type) {
    case UPDATE_CONSENT_TEXT:
      return {
        ...state,
        consentText: action.payload,
      }
    case SIGN_CONSENT:
      return {
        ...state,
        isConsentSigned: action.payload,
      }
    case CHECK_TERMS:
      return {
        ...state,
        isTermsChecked: action.payload,
      }
    default:
      return state
  }
}
